<template>
  <div class="login">
    <el-form ref="form" :model="form" :rules="rules" class="login-form">
      <h3 class="title">智慧水务管理系统</h3>
      <el-form-item prop="username">
        <el-input
                v-model="form.username"
                type="text"
                auto-complete="off"
                placeholder="账号"
                :clearable="true"
        >

        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
                v-model="form.password"
                type="password"
                auto-complete="off"
                placeholder="密码"
                @keyup.enter.native="handleLogin"
                :clearable="true"
                :show-password="true"
        >

        </el-input>
      </el-form-item>
      <el-form-item prop="code" >
        <el-input
                v-model="form.captchaCode"
                auto-complete="off"
                placeholder="验证码"
                style="width: 63%"
                @keyup.enter.native="handleLogin"
                :clearable="true"
        >
        </el-input>
        <div class="login-code">
          <img :src="captchaBase" @click="getCaptchaBases" class="login-code-img"/>
        </div>
      </el-form-item>
      <!--            <el-checkbox v-model="form.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>-->
      <el-form-item style="width:100%;">
        <el-button
                size="medium"
                type="primary"
                style="width:100%;"
                @click.native.prevent="handleLogin"
        >
          <span @click="handleLogin">登 录</span>
        </el-button>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
      <!--            <span>Copyright © 2018-2022 ruoyi.vip All Rights Reserved.</span>-->
    </div>
  </div>
</template>

<script>
  import {setToken} from "@/utils/dataStorage";

  export default {
    name: "Login",
    data() {
      return {
        form: {
          username: "",
          password: "",
          captchaId:0,
          captchaCode:'',
        },
        captchaBase:"",
        rules: {
          username: [
            {required: true, message: '请输入账号', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            {min: 6, message: '密码长度不小于6位', trigger: 'blur'}
          ]
        }
      };
    },
    created() {
      this.getCaptchaBases();
    },
    methods: {
      getCaptchaBases(){
        this.$get(this.$url.获取图形验证码, {})
                .then((resp) => {
                  this.captchaBase = resp.base64
                  this.form.captchaId = resp.captchaId
                })
                .catch((e) => {})
      },
      handleLogin() {
        this.$refs['form'].validate((valid) => {
          console.log("valid",valid)
          if (valid) {
            this.$post(this.$url.login, {...this.form}).then(resp => {
              setToken(resp.token);
              /**
               * 触发刷新vuex store  必须做，否则无法刷新store检测的值
               */
              this.$store.commit('isLogin')
              this.$router.push({name: "App"});
            }).catch(error =>{
              //刷新验证码
              this.getCaptchaBases()
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });

      }
    }
  };
</script>

<style  lang="less">
  .login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    background-image: url("../assets/images/login-background.jpg");
    background-size: cover;
  }

  .title {
    margin: 0px auto 30px auto;
    text-align: center;
    color: #707070;
  }

  .login-form {
    border-radius: 6px;
    background: #ffffff;
    width: 400px;
    padding: 25px 25px 5px 25px;

    .el-input {
      height: 38px;

      input {
        height: 38px;
      }
    }

    .input-icon {
      height: 39px;
      width: 14px;
      margin-left: 2px;
    }
  }

  .login-tip {
    font-size: 13px;
    text-align: center;
    color: #bfbfbf;
  }

  .login-code {
    width: 33%;
    height: 38px;
    float: right;

    img {
      cursor: pointer;
      vertical-align: middle;
    }
  }

  .el-login-footer {
    height: 40px;
    line-height: 40px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: Arial;
    font-size: 12px;
    letter-spacing: 1px;
  }

  .login-code-img {
    height: 38px;
  }
</style>
